import Typography from "antd/lib/typography";
import {Button, Checkbox, Col, Flex, GetProps, Input, Row, Select, Spin} from "antd";
import Search from "antd/lib/input/Search";
import React, {useEffect, useState} from "react";
import {
    competitionsStore,
    concourseGroupsStore,
    IConcourseGroup,
    IKindsLevelFormation,
    ISpecialityProfile,
    kindsLevelFormationsStore,
    resultStore
} from "../../../store/admissions/admissionStore";
import {getRequest, getRequestWithParams} from "../../../api/httpRequest";
import "../styles/style.less"
import Result from "antd/lib/result";
import {FaArrowCircleUp} from "react-icons/fa";
import {filterStore, stepsStore} from "../../../store/admissions/stepperStore";
import dayjs from "dayjs";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import {userStore} from "../../../store/store";
import {useNavigate} from "react-router";

type SearchProps = GetProps<typeof Input.Search>;

export const countConstraints = new Map<string, number>([
    ["БАКСПЕЦ", 5],
    ["СПО11КЛАССОВ", 5],
    ["СПО9КЛАССОВ", 5]
]);

export default function Step2(props: { title: string, edit?: boolean }) {

    const {stepsData, setStepsData} = stepsStore();
    const {result, setResult} = resultStore()
    const {kindsLevelFormations, setKindsLevelFormations} = kindsLevelFormationsStore();
    const {competitions, setCompetitions} = competitionsStore()
    const [kindsTraining, setKindsTraining] = useState<IKindsLevelFormation[]>([])
    const {concourseGroups, setConcourseGroups} = concourseGroupsStore();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [existStatement, setExistStatement] = useState<any>();
    const {xl} = useBreakpoint()
    const {user, setUser} = userStore();
    const navigate = useNavigate();
    const [existsSpeciality, setExistSpeciality] = useState<string[]>([]);

    const {filter, setFilter} = filterStore();

    useEffect(() => {
        const getKindsLevels = async () => {
            setIsLoading(true);
            getRequestWithParams(`/server/proxy/contracts/getConcourseGroup`, {countries: user.country})
                .then(response => {
                    setCompetitions(response.data.competition);
                    setConcourseGroups(response.data.concourseGroups);
                    setKindsLevelFormations(response.data.kindsLevelFormation);
                    setKindsTraining(response.data.kindsTraining);
                    setIsLoading(false);
                })
        }

        getKindsLevels()

    }, []);

    const onNameSearch: SearchProps['onSearch'] = (value: string, _e: any, info: any) => {
        setFilter({...filter, name: value.toLowerCase()});
    };

    const onStatementExistsCheck = (kindsLevelFormation: string | null, basistraining: string | null) => {
        getRequest(`/server/proxy/contracts/PrevSent?level=${kindsLevelFormation}&basistraining=${basistraining}`)
            .then(response => {
                if (response.data.spec && response.data.spec.length > 1) {
                    setExistSpeciality(response.data.spec)
                }
                if (response.data && response.data.doc.length > 0) {
                    setExistStatement(response.data.doc[0]);
                    return true;
                } else {
                    setExistStatement(false);
                    return false;
                }
            })
    }

    const stringFilter = (group: IConcourseGroup, search: string) => {
        if (group.specQualifier.toLowerCase().includes(search)) {
            return true
        }
        if (group.specName.toLowerCase().includes(search)) {
            return true
        }
        group.profiles.forEach((profile: ISpecialityProfile) => {
            if (profile.name.toLowerCase().includes(search)) {
                return true
            }
        })
        return false
    }

    const filterConcourseGroups = () => {
        return concourseGroups.filter((item: IConcourseGroup) => {
            let show = true;
            if (filter.name !== null && !stringFilter(item, filter.name)) {
                show = false
            }
            if (filter.kindsTraining !== null && item.kindsTraining.value !== filter.kindsTraining) {
                show = false
            }
            if (filter.basistraining !== null && item.basistraining !== filter.basistraining) {
                show = false
            }
            if (filter.kindsLevelFormation !== null && item.kindsLevelFormation.value !== filter.kindsLevelFormation) {
                show = false
            }
            if (filter.competition !== null && item.competitioncode !== filter.competition) {
                show = false
            }
            return show;
        })

    }

    const isFiltersDone = () => {
        return filter.kindsTraining !== null
            && filter.basistraining !== null
            && filter.kindsLevelFormation !== null
            && filter.competition !== null
    }

    const getCountConstraints = () => {
        if (filter.kindsLevelFormation === null || filter.kindsLevelFormation === undefined) {
            return 0;
        } else {
            const res = countConstraints.get(filter.kindsLevelFormation);
            if (res === undefined) {
                return 0;
            } else {
                return res;
            }
        }
    }

    const getProfileText = (concourseGroup: IConcourseGroup) => {
        if (concourseGroup.kindsLevelFormation.name === "Бакалавриат") {
            if (concourseGroup.profiles.length === 1) {
                return "Профиль"
            } else {
                return "Профили"
            }
        } else if (concourseGroup.kindsLevelFormation.name === "Специалитет") {
            if (concourseGroup.profiles.length === 1) {
                return "Специализация"
            } else {
                return "Специализации"
            }
        } else if (concourseGroup.kindsLevelFormation.name === "Магистратура") {
            if (concourseGroup.profiles.length === 1) {
                return "Направленность"
            } else {
                return "Направленности"
            }
        }
    }

    const checkCardDisabled = (concourseGroup: IConcourseGroup) => {
        if (existsSpeciality.includes(concourseGroup.specQualifier)) {
            return false
        }
        return getCountConstraints() !== 0 && result.selectedSpecQualifier.length >= getCountConstraints() - existsSpeciality.filter(item => !result.selectedSpecQualifier.includes(item)).length && !result.selectedSpecQualifier.includes(concourseGroup.specQualifier)
    }

    const ConcourseCard: React.FC<{
        concourseGroup: IConcourseGroup,
        disabled?: boolean,
    }> = ({concourseGroup, disabled}) => {
        return (
            <Flex
                className={xl ? "admission-speciality-card" : "admission-speciality-card-mobile"}
                vertical={true} justify={"space-between"}>
                <Typography.Text style={{padding: "8px 16px", backgroundColor: "whitesmoke"}}
                                 strong>{concourseGroup.specQualifier} {concourseGroup.specName}</Typography.Text>
                <Flex justify={"space-between"} style={{padding: "16px", width: "100%"}} vertical={!xl}>
                    <Flex vertical={true} gap={16}>
                        {concourseGroup.profiles.length > 0 &&
                            <Typography.Text>{`${getProfileText(concourseGroup)}: ${concourseGroup.profiles.map(item => item.name).join(", ")};`}</Typography.Text>
                        }
                        <Flex style={{width: '100%'}} vertical={true}>
                            <Typography.Text>{`Уровень образования: ${concourseGroup.kindsLevelFormation.name};`}</Typography.Text>
                            <Typography.Text>{`Форма обучения: ${concourseGroup.kindsTraining.display};`}</Typography.Text>
                            <Typography.Text>{`Вид конкурса: ${competitions.find(item => item.value === concourseGroup.competitioncode)?.display};`}</Typography.Text>
                            <Typography.Text>{`Основа обучения: ${concourseGroup.basistraining};`}</Typography.Text>
                            {concourseGroup.basistraining !== "бюджетная" &&
                                <Typography.Text>{`Цена за полгода: ${concourseGroup.price}${(concourseGroup.specQualifier === "25.03.03" && concourseGroup.profiles.find(item => item.name === "Летная эксплуатация гражданских воздушных судов")) ? " * не включает в себя стоимость летной практики" : ""};`}</Typography.Text>}
                            <Typography.Text>{`Количество мест: ${concourseGroup.number}.`}</Typography.Text>
                        </Flex>
                    </Flex>
                    <Flex style={{width: 'auto'}} align={"center"} justify={"flex-end"}>
                        <Checkbox
                            disabled={checkCardDisabled(concourseGroup)}
                            checked={result.selectedConcourceGroupsCodes.includes(concourseGroup.concourseGroupsCode)}
                            onChange={(event) => {

                                let newGroups = result.selectedConcourceGroupsCodes;
                                if (event.target.checked) {
                                    newGroups.push(concourseGroup.concourseGroupsCode)
                                } else {
                                    const index = newGroups.indexOf(concourseGroup.concourseGroupsCode, 0);
                                    if (index > -1) {
                                        newGroups.splice(index, 1);
                                    }
                                }

                                let newSpecs = result.selectedSpecQualifier;

                                if (event.target.checked) {
                                    if (!result.selectedSpecQualifier.includes(concourseGroup.specQualifier)) {
                                        newSpecs.push(concourseGroup.specQualifier)
                                    }
                                } else {
                                    const index = newSpecs.indexOf(concourseGroup.specQualifier, 0);
                                    if (index > -1) {
                                        newSpecs.splice(index, 1);
                                    }
                                }
                                setResult({
                                    ...result,
                                    selectedConcourceGroupsCodes: newGroups,
                                    selectedSpecQualifier: newSpecs
                                })
                                setStepsData({...stepsData, nextStep: newSpecs.length > 0})
                            }}
                        >{result.selectedConcourceGroupsCodes.includes(concourseGroup.concourseGroupsCode) ? "Выбрано" : "Выбрать"}</Checkbox>
                    </Flex>
                </Flex>
            </Flex>
        )
    }

    return (
        <Flex style={{height: "90%"}} vertical={true} justify={"space-around"} align={"center"} gap={16}>
            <Typography.Text strong style={xl ? {fontSize: "20px"} : {
                padding: "0 16px",
                fontSize: "16px"
            }}>{`${props.title}`}</Typography.Text>
            <Row gutter={[16, 16]} style={xl ? {} : {padding: "16px"}}>
                <Col>
                    <Flex style={{width: "auto"}} align={"center"} justify={"center"} gap={8}>
                        <Typography.Text>Основа обучения:</Typography.Text>
                        <Select
                            style={{width: "200px"}}
                            placeholder={"Выберите"}
                            disabled={props.edit}
                            defaultValue={filter.basistraining}
                            onChange={(value: any) => {
                                setFilter({...filter, basistraining: value})
                                setResult({
                                    ...result,
                                    basistraining: value,
                                    selectedConcourceGroupsCodes: [],
                                    selectedSpecQualifier: []
                                })
                                onStatementExistsCheck(filter.kindsTraining, value);
                                setStepsData({...stepsData, nextStep: false})
                            }}
                            options={[
                                {
                                    label: `Бюджетная`,
                                    value: `бюджетная`
                                },
                                {
                                    label: `Платная`,
                                    value: `платная`
                                }
                            ]
                            }
                        />
                    </Flex>
                </Col>
                <Col>
                    <Flex style={{width: "auto"}} align={"center"} justify={"center"} gap={8}>
                        <Typography.Text>Уровень образования:</Typography.Text>
                        <Select
                            style={{width: "200px"}}
                            placeholder={"Выберите"}
                            defaultValue={filter.kindsLevelFormation}
                            popupMatchSelectWidth={false}
                            disabled={props.edit}
                            onChange={(value: any) => {
                                setFilter({...filter, kindsLevelFormation: value})
                                setResult({
                                    ...result,
                                    kindsLevelFormation: value,
                                    selectedConcourceGroupsCodes: [],
                                    selectedSpecQualifier: []
                                })
                                onStatementExistsCheck(value, filter.basistraining);
                                setStepsData({...stepsData, nextStep: false})
                            }}
                            options={kindsLevelFormations.map((item) => ({value: item.value, label: item.display}))}
                        />
                    </Flex>
                </Col>
                <Col>
                    <Flex style={{width: "auto"}} align={"center"} justify={"center"} gap={8}>
                        <Typography.Text>Форма обучения:</Typography.Text>
                        <Select
                            style={{width: "200px"}}
                            disabled={existStatement}
                            placeholder={"Выберите"}
                            defaultValue={filter.kindsTraining}
                            popupMatchSelectWidth
                            onChange={(value: any) => {
                                setFilter({...filter, kindsTraining: value})
                                setResult({...result, kindsTrainingCode: value})
                            }}
                            options={kindsTraining.map((item) => ({value: item.value, label: item.display}))}
                        />
                    </Flex>
                </Col>
                <Col>
                    <Flex style={{width: "auto"}} align={"center"} justify={"center"} gap={8}>
                        <Typography.Text>Вид конкурса:</Typography.Text>
                        <Select
                            style={{width: "200px"}}
                            disabled={existStatement}
                            placeholder={"Выберите"}
                            popupMatchSelectWidth
                            defaultValue={filter.competition}
                            onChange={(value: any) => {
                                setFilter({...filter, competition: value})
                                setResult({...result, competition: value})
                            }}
                            options={competitions.map(item => ({value: item.value, label: item.display}))
                            }/>
                    </Flex>
                </Col>
            </Row>
            <Search
                style={{width: "400px", padding: xl ? "" : "0 16px"}}
                placeholder="Поиск"
                allowClear
                enterButton="Найти"
                size="small"
                onSearch={onNameSearch}
            />
            <Flex className={"admission-step-2-list"} justify={"center"}>
                {!existStatement &&
                    <>
                        {!isFiltersDone() ?
                            <Flex style={{width: "100%"}} align={"center"} justify={"center"}>
                                <Result
                                    icon={<FaArrowCircleUp color={"#1677ff"} size={64}/>}
                                    title="Установите значения всех фильтров выше"
                                />
                            </Flex> :
                            isLoading ? <Spin/> :
                                <Row gutter={[16, 16]} justify={"center"}>
                                    {filterConcourseGroups().length > 0 ? filterConcourseGroups().map((item: IConcourseGroup, index: number) => {
                                            return (
                                                <Col key={index} style={xl ? {} : {width: "90%"}}>
                                                    <ConcourseCard concourseGroup={item}/>
                                                </Col>
                                            )
                                        }) :
                                        <Flex style={{width: "100%"}} align={"center"} justify={"center"}>
                                            <Result
                                                icon={<FaArrowCircleUp color={"#fd9125"} size={64}/>}
                                                title="Отсутствуют подходящие конкурсные группы. Измените значения фильтров выше"
                                            />
                                        </Flex>
                                    }
                                </Row>
                        }
                    </>
                }
                {existStatement &&
                    <Flex style={{width: "100%"}} align={"center"} justify={"center"}>
                        <Result
                            title={`Вы уже подали заявление №${existStatement.Number} от ${dayjs(existStatement.Date).format(`DD.MM.YYYY`)}`}
                            extra={
                                <Button type="primary" key="console"
                                        onClick={() => {
                                            navigate("/admission")
                                        }}
                                >
                                    К списку заявлений
                                </Button>
                            }
                        />
                    </Flex>}
            </Flex>
            {getCountConstraints() > 0 &&
                <Typography.Text strong>Осталось выбрать уникальных
                    специальностей: {`${getCountConstraints() - result.selectedSpecQualifier.filter(item => !existsSpeciality.includes(item)).length - existsSpeciality.length}`}</Typography.Text>
            }
        </Flex>
    )
}
